// useScrollLock.ts
import { useEffect, useRef } from 'react'

export function useScrollLock(locked: boolean) {
  const scrollYRef = useRef(0)

  useEffect(() => {
    const body = document.body
    const docEl = document.documentElement

    if (locked) {
      // save current scroll
      scrollYRef.current = window.scrollY || window.pageYOffset

      // prevent layout shift by reserving scrollbar space (desktop)
      const scrollBarWidth = window.innerWidth - docEl.clientWidth
      if (scrollBarWidth > 0) body.style.paddingRight = `${scrollBarWidth}px`

      // iOS-safe lock: fix the body at its current scroll position
      body.style.position = 'fixed'
      body.style.top = `-${scrollYRef.current}px`
      body.style.left = '0'
      body.style.right = '0'
      body.style.width = '100%'
      body.style.overflow = 'hidden' // belt & suspenders

      // (Optional) signal lock via class if you want CSS hooks
      docEl.classList.add('is-scroll-locked')
    } else {
      // restore styles first
      body.style.removeProperty('position')
      body.style.removeProperty('top')
      body.style.removeProperty('left')
      body.style.removeProperty('right')
      body.style.removeProperty('width')
      body.style.removeProperty('overflow')
      body.style.removeProperty('padding-right')
      document.documentElement.classList.remove('is-scroll-locked')

      // then restore scroll position without jump
      window.scrollTo({ top: scrollYRef.current })
    }

    // cleanup if unmounted while locked
    return () => {
      if (locked) {
        body.style.cssText = ''
        document.documentElement.classList.remove('is-scroll-locked')
        window.scrollTo({ top: scrollYRef.current })
      }
    }
  }, [locked])
}
